import { render, staticRenderFns } from "./Email-ricevuta.vue?vue&type=template&id=29eec7bb&"
import script from "./Email-ricevuta.vue?vue&type=script&lang=js&"
export * from "./Email-ricevuta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports